import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { Color } from '../../../../styles/Color';
import { Z_INDEX_MAIN_NAV_ITEM } from '../../../../styles/zIndex';
import { UnstyledLi, Css, Responsive, getHeaderStyleCss } from '../../../../ui';
import {
	getNavigationItemColor,
	MainNavigationItemCommon,
} from '../Navigation.styles';
import { rotate } from '../../../../styles/animation/rotate';
import { RouterLink } from '../../link/RouterLink';
import { swipe } from '../../../../styles/animation/swipe';

export const NavListItem = styled(UnstyledLi)<{
	isActive: boolean;
	open: boolean;
}>`
	width: fit-content;
	display: flex;
	z-index: ${Z_INDEX_MAIN_NAV_ITEM};
	padding-bottom: ${Css.pxToRem(1)};

	${({ isActive }) =>
		isActive && `border-bottom: 1px solid ${Color.OnBackgroundText};`}

	&:last-child {
		ul {
			border-top-right-radius: 0;
			border-top-left-radius: ${Css.pxToRem(16)};
			right: 0;
		}
	}
	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		pointer-events: all;
		width: 100%;
		border-bottom: none;
		${({ open }) => swipe(open, true)}
	}
`;

export const NavButton = styled.button<{
	isActive: boolean;
	isSubmenuOpen: boolean;
}>`
	border: none;
	cursor: pointer;
	background: none;
	padding: 0;
	${MainNavigationItemCommon};

	display: flex;
	align-items: start;

	${({ isSubmenuOpen, isActive }) =>
		getNavigationItemColor(isActive, isSubmenuOpen)};

	svg {
		${({ isActive }) => rotate(isActive)}
	}
	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		svg {
			${rotate(false)}
		}
	}
`;

export const NavLabel = styled.p`
	margin: 0;
	width: max-content;

	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		${getHeaderStyleCss('h6')};
		margin: 0;
	}
`;

export const NavLink = styled(RouterLink, {
	shouldForwardProp: (props) => isPropValid(props),
})<{
	isActive: boolean;
	isSubmenuOpen: boolean;
}>`
	text-decoration: none;

	${MainNavigationItemCommon};
	${({ isSubmenuOpen, isActive }) =>
		getNavigationItemColor(isActive, isSubmenuOpen)};
`;
